import React, { useState } from 'react'

const faqItems = [
  { id: 1, q: 'Why Choose You as the Best Mobile App Development Company?', a: 'As the best mobile app development company, we focus on creating high-performance and user-friendly applications tailored to your business goals.' },
  { id: 2, q: 'Do You Develop Apps for both Android and iOS Platforms?', a: 'Yes! We provide complete cross-platform and native app solutions. As an experienced iOS app development company, we build feature-rich applications for both iOS and Android devices to maximise your market reach.' },
  { id: 3, q: 'Can You Build Custom Mobile Apps for My Business?', a: 'Absolutely. Our team works closely with businesses to create customised mobile applications based on industry requirements, user expectations, and long-term growth strategies.' },
  { id: 4, q: 'Do You Have Experienced App Developers in Pakistan?', a: 'Yes, our skilled team includes experienced app developers in Pakistan who specialise in building secure, scalable, and innovative mobile applications for startups, enterprises, and growing businesses.' },
  { id: 5, q: 'Do You Offer Android App Development Services?', a: 'Definitely! As a trusted Android app development agency, we create responsive and high-performing Android applications designed to improve user engagement, business efficiency, and customer experience.' },
]

export default function Faq2({ items: customItems, heading = 'FAQs - Let’s Talk Details', intro }) {
  const items = customItems || faqItems
  const [openId, setOpenId] = useState(items[0]?.id || 1)
  const toggle = (id) => setOpenId(openId === id ? -1 : id)
  return (
    <section style={{ backgroundColor: '#151619' }}>
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-6">
            <div>
              <h2 className="text-light">{heading}</h2>
              <p className="text-light text-opacity-75">
              {intro || 'Ready to take your project to the next level? Contact Metatech Official today and get expert advice to make it happen seamlessly.'}
              </p>
              <div className="mt-4">
                <a className="btn btn-primary rounded-pill" href="/seo-contact" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                  Ask your questions
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-5 offset-lg-1">
            <div>
              {items.map((f) => (
                <div key={f.id} className="my-3 p-3 rounded-4" style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}>
                  <div className="d-flex justify-content-between align-items-center" style={{ cursor: 'pointer' }} onClick={() => toggle(f.id)}>
                    <h3 className="h6 m-0 text-light">{f.q}</h3>
                    <span className="text-light" style={{ transform: openId === f.id ? 'rotate(45deg)' : 'rotate(0)', transition: 'transform .3s' }}>+</span>
                  </div>
                  {openId === f.id && <div className="pt-2 text-light text-opacity-75">{f.a}</div>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}


